<template>
  <main class="bg-white py-16" ref="propertiesSection">
    <!-- Discover your path text section -->
    <div class="md:px-10 max-w-screen-4xl mx-auto px-6 lg:px-12">
      <h1 class="text-center text-xl font-semibold text-yellow mt-10 uppercase">
        Our Properties
      </h1>
      <p class="text-center text-gray-900 text-2xl mt-3 font-normal">
        Discover The Different Options We Have
      </p>
    </div>

    <!-- Discover your path card section -->
    <div class="lg:px-12 px-4">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-10 mt-10">
        <div
          v-for="(person, index) in persons"
          :key="index"
          :class="[
            'group relative overflow-hidden flex flex-col rounded-lg animate-slide cursor-pointer',
            { 'slide-left': index % 2 === 0, 'slide-right': index % 2 !== 0 },
          ]"
        >
          <!-- Image with overlay -->
          <div class="relative group">
            <div class="absolute inset-0 bg-black bg-opacity-30 z-10"></div>
            <div class="aspect-[3/4] overflow-hidden max-h-[500vw]">
              <img
                :src="person.image"
                alt="person image"
                class="w-full h-full object-cover transition-transform duration-500 transform group-hover:scale-105"
              />
            </div>
          </div>

          <!-- Title inside image -->
          <div
            class="absolute bottom-12 left-0 right-0 text-white font-black text-3xl font-style text-start px-4 z-20 transition-all duration-500 transform translate-y-0 group-hover:-translate-y-14 group-hover:text-blue"
          >
            <span>{{ person.title }}</span>
          </div>
          <div
            class="absolute bottom-4 left-0 right-0 text-white text-base text-start px-4 z-20 transition-all duration-500 transform translate-y-0 group-hover:-translate-y-4 group-hover:text-blue"
          >
            <button>
              View project
              <span class="mx-2 text-xs"
                ><i class="fa-solid fa-arrow-right"></i
              ></span>
            </button>
          </div>

          <!-- Hover effect (description with transparent dark background) -->
          <div
            class="absolute inset-0 bg-yellow bg-opacity-80 flex flex-col items-center justify-center text-center text-white opacity-0 group-hover:opacity-100 duration-500 transform translate-y-full group-hover:translate-y-0 transition-transform z-10"
          ></div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
      persons: [
        {
          title: "Sites & Services",
          image: require("../assets/images/MAGNOLIA.png"),
        },
        {
          title: "Ultra",
          image: require("../assets/images/MAZARI.png"),
        },
        {
          title: "3rd Party Sale",
          image: require("../assets/images/belle-vista.png"),
        },
      ],
    };
  },
  mounted() {
    this.isVisible = false; // Initialize as false

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            this.$refs.propertiesSection.classList.add("animate-slide-left");
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(this.$refs.propertiesSection);
  },
};
</script>

<style scoped>
.group-hover\:scale-105 {
  transform: scale(1.05);
}
.group-hover\:opacity-100 {
  opacity: 1;
}
.transition-opacity {
  transition: opacity 0.5s ease;
}
.transition-transform {
  transition: transform 0.5s ease;
}
.opacity-0 {
  opacity: 0;
}
.group-hover\:opacity-100 {
  opacity: 1;
}
.story-style {
  font-family: "Caveat";
}
.font-style {
  font-family: "Montserrat";
}

@keyframes slideFromLeft {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideFromRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.slide-left {
  animation: slideFromLeft 0.8s ease-out forwards;
}

.slide-right {
  animation: slideFromRight 0.8s ease-out forwards;
}
</style>
